module.exports = __webpack_public_path__ + "img/mic-white.67c5f2d8.svg";